module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_banner_bg.7a5c8fd0.png";